import React from "react";
import { FaBullhorn } from "react-icons/fa";

function AnnouncementBar() {
  console.log('AnnouncementBar rendered');
    return (
      <div style={{
        position: "fixed",
        background: "#FCB541",
        color: "#330A0A",
        display: "flex",
        paddingTop: "2em",
        paddingBottom: "0.5em",
        textAlign: "center",
        fontWeight: "bold",
        fontFamily: "Open Sans",
        fontSize: "1.1em",
        zIndex: 9999,
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          whiteSpace: "nowrap",
          animation: "announcement-marquee 24s linear infinite"
        }}>
          <FaBullhorn style={{marginRight: "0.5em"}} />
          <span>New Admissions open from Vijayadashami - October 2nd, 2025. Batches available for Beginners, Intermediate and Advanced. Please refer 'Connect with us' section for contact details.</span>
        </div>
        <style>{`
          @keyframes announcement-marquee {
            0% { transform: translateX(100%); }
            100% { transform: translateX(-100%); }
          }
        `}</style>
      </div>
  );
}

export default AnnouncementBar;